function FolderLock({
  color = 'currentColor',
  size = 20,
  strokeWidth = 0.666667,
}: {
  color?: string
  size?: number
  strokeWidth?: number
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M7.08301 10.9167C7.08301 10.45 7.08301 10.2166 7.17384 10.0384C7.25373 9.88156 7.38121 9.75408 7.53802 9.67418C7.71628 9.58335 7.94963 9.58335 8.41634 9.58335H11.583C12.0497 9.58335 12.2831 9.58335 12.4613 9.67418C12.6181 9.75408 12.7456 9.88156 12.8255 10.0384C12.9163 10.2166 12.9163 10.45 12.9163 10.9167V11.5834C12.9163 12.0501 12.9163 12.2834 12.8255 12.4617C12.7456 12.6185 12.6181 12.746 12.4613 12.8259C12.2831 12.9167 12.0497 12.9167 11.583 12.9167H8.41634C7.94963 12.9167 7.71628 12.9167 7.53802 12.8259C7.38121 12.746 7.25373 12.6185 7.17384 12.4617C7.08301 12.2834 7.08301 12.0501 7.08301 11.5834V10.9167Z"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.54134 8.12502C8.54134 7.31961 9.19426 6.66669 9.99967 6.66669C10.8051 6.66669 11.458 7.31961 11.458 8.12502V9.58335H8.54134V8.12502Z"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.2812 10.8752C18.009 13.4335 16.5604 15.8309 14.1632 17.2157C10.1805 19.5165 5.08787 18.1511 2.78846 14.166L2.54356 13.7416M1.71843 9.12483C1.99057 6.56654 3.43924 4.16918 5.83639 2.78434C9.81908 0.483548 14.9117 1.84894 17.2111 5.83404L17.456 6.25849M1.6665 15.946L2.38365 13.268L5.06005 13.9856M14.9396 6.01442L17.616 6.732L18.3332 4.05397"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default FolderLock
